<template>
  <div
    class="bottomNav border fixed background bottom-0 h-12k inset-x-0 grid grid-cols-5 shadow-inner bg-white rounded-t-2xl"
  >
    <BottomNavItem
      @click="$store.commit('currentComponent', item.title)"
      v-for="item in bottomNavItems"
      :title="item.title"
      :iconActive="item.iconActive"
      :iconInactive="item.iconInactive"
      :key="item"
    />
  </div>
</template>

<script>
import BottomNavItem from "@/views/bottomnav/BottomNavItem.vue";
export default {
  components: { BottomNavItem },
  data() {
    return {
      bottomNavItems: [
        {
          title: "Home",
          iconActive: require("@/assets/icons/bnv/bnvhomefill.svg"),
          iconInactive: require("@/assets/icons/bnv/bnvhome.svg"),
        },
        {
          title: "Menu",
          iconActive: require("@/assets/icons/bnv/bnvmenufill.svg"),
          iconInactive: require("@/assets/icons/bnv/bnvmenu.svg"),
        },
        {
          title: "Cart",
          iconActive: require("@/assets/icons/bnv/bnvcartfill.svg"),
          iconInactive: require("@/assets/icons/bnv/bnvcart.svg"),
        },
        {
          title: "Orders",
          iconActive: require("@/assets/icons/bnv/bnvordersfill.svg"),
          iconInactive: require("@/assets/icons/bnv/bnvorders.svg"),
        },
        {
          title: "More",
          iconActive: require("@/assets/icons/bnv/bnvmorefill.svg"),
          iconInactive: require("@/assets/icons/bnv/bnvmore.svg"),
        },
      ],
    };
  },
};
</script>
<style scoped>
.bottomNav {
  padding-bottom: env(safe-area-inset-bottom);
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
}
</style>
